import { eEasing } from '@models/classes/enums';
import { SetMap } from '@models/classes/handlers';
import { Kb3dManager } from '@models/classes/kb3d-manager';
import { KbColor } from '@models/classes/primitives/kb-color';
import { KbVector } from '@models/classes/primitives/kb-vector';
import { SceneNode } from '@models/classes/scene-node';
import { Token } from '@models/classes/token';
import { topologicalSort } from '@view/helpers/graph-helper';
import { KbViewer } from '@view/kb-viewer';

export function kb3dTest() {
    let map = new SetMap<string, string>();
    map.add('A', 'B', 'C');
    map.add('B', 'C', 'D');
    map.add('C', 'E');
    map.add('D', 'E', 'F');
    map.add('E');
    map.add('F');
    map.add('G', 'F', 'E');
    topologicalSort(map, s => s);

    map = new SetMap<string, string>();
    map.add('0', '1', '2');
    map.add('1', '2');
    map.add('2', '0', '3');
    map.add('3');
    topologicalSort(map, s => s);

    map = new SetMap<string, string>();
    map.add('2');
    map.add('3', '8', '10');
    map.add('5', '11');
    map.add('7', '8', '11');
    map.add('8', '9');
    map.add('9');
    map.add('10');
    map.add('11', '2', '9', '10');
    topologicalSort(map, s => s);

    const kbViewer = new KbViewer({ container: document.getElementById('viewer-div') as HTMLElement });
    let manager = new Kb3dManager({ assetRoot: '' }); //default services automatically used
    let sceneNode = manager.create(Token.SceneNode);
    sceneNode.backgroundColor = new KbColor(0.9, 0.9, 0.9, 1);
    sceneNode.enableHoverEffects = true;
    kbViewer.loadScene({ sceneNode });

    const group = manager.create(Token.MeshGroupNode);

    const box = manager.create(Token.BoxNode);
    const boxId = box.id;
    group.meshes.push(box);

    // let blah = manager.getById(boxId);
    // let db = manager.getAll().map(n => { return { id: n.id, name: n.name, type: n.$type }; });
    // alert(JSON.stringify(db, null, 2));

    // sceneNode.meshes.push(group);
    // db = manager.getAll().map(n => { return { id: n.id, name: n.name, type: n.$type }; });
    // alert(JSON.stringify(db, null, 2));

    // setTimeout(() => {
    //     sceneNode.meshes.remove(group);
    //     db = manager.getAll().map(n => { return { id: n.id, name: n.name, type: n.$type }; });
    //     alert(JSON.stringify(db, null, 2));
    // }, 500);

    //sceneNode.meshes.push(box);

    // function animate(time: number) {
    //     requestAnimationFrame(animate);
    //     TWEEN.update(time);
    // }
    // requestAnimationFrame(animate);

    // let pos = { x: box.position.x, y: box.position.y, z: box.position.z };
    // const anim = new TWEEN.Tween(pos)
    //     .to({ x: 3, y: 0, z: 0 }, 5000)
    //     .onUpdate(() => {
    //         box.position = KbVector.From(pos);
    //     })
    //     .start();

    // let group = manager.create(Token.MeshGroupNode);
    // group.rotation = new KbVector(0, 0, 0);
    // sceneNode.meshes.push(group);

    // let box = manager.create(Token.BoxNode);
    // let boxId = box.id;
    // box.materialId = "bricks01";
    // group.meshes.push(box);

    // let conn1 = manager.create(Token.Connector, {
    //     positionMode: eConnectorPositionMode.boundingBox,
    //     position: new KbVector(0, 1, 1),
    //     direction: new KbVector(0, 0, 1)
    // });
    // box.features.push(conn1);

    // let mat = manager.create(Token.AdvancedMaterialNode, {
    //     albedoColor: new KbColor(1, 0, 0),
    //     backFaceCulling: false
    // });
    // sceneNode.materials.push(mat);
    // box.materialId = mat.id;

    // let sphere = manager.create(Token.SphereNode, {
    //     diameter: 1,
    //     position: new KbVector(2, 0,0)
    // });
    // group.meshes.push(sphere);

    // let box2 = manager.create(Token.BoxNode);
    // sceneNode.meshes.push(box2);
    // box2.position = new KbVector(0, 0, 3);
    // box2.width = 2;
    // let conn3 = manager.create(Token.Connector, {
    //     positionMode: eConnectorPositionMode.absolute,
    //     position: new KbVector(0, 0, -0.5),
    //     direction: new KbVector(0, 0, -1),
    //     angle: 0
    // });
    // let conn4 = manager.create(Token.Connector, {
    //     positionMode: eConnectorPositionMode.absolute,
    //     position: new KbVector(1, 0, 0),
    //     direction: new KbVector(1, 0, 0),
    //     angle: 30
    // });
    // let conn5 = manager.create(Token.Connector, {
    //     positionMode: eConnectorPositionMode.absolute,
    //     position: new KbVector(0, .5, 0),
    //     direction: new KbVector(0, 1, 0),
    //     angle: 0
    // });
    // box2.features.push(conn3);
    // box2.features.push(conn4);
    // box2.features.push(conn5);

    // manager.draggables.add(group.id, "blah", {
    //     mode: eDragMode.free,
    //     //surfaceNodes: [sphere.id, sphere2.id],
    //     planeNormal: new KbVector(0, 1, 0),
    //     // planeOrigin: new KbVector(0,0,0),
    //     //disableOffset: false,
    //     connectionMode: eConnectionMode.screen,
    //     showConnectors: true,
    //     connectRadius: 10,
    //     dragOpacity: .3,
    //     dragStart: (a) => {

    //     },
    //     dragging: (a) => {

    //     },
    //     dropped: (a) => {

    //     },
    //     // canConnect: (a) => {
    //     //     a.
    //     // }
    // });

    // kbViewer.interaction.onPointerUp.subscribe(p => {
    //     console.log(kbViewer.getScreenPositionOfNode(box));
    //     console.log(kbViewer.getScreenBoundingBoxOfNode(box));
    // });

    const light = manager.create(Token.DirectionalLightNode);
    sceneNode.lights.push(light);

    // let mat = manager.create(tok.AdvancedMaterialNode, {
    //     albedoColor: new KbColor(252, 0, 0)
    // });
    // sceneNode.materials.push(mat);
    // box.materialId = mat.id;

    //box.materialId = "4454a0e3-e1e4-42d4-aea5-6915681bfc12";

    // for (let row = 0; row < 10; row++){
    //     for (let col = 0; col < 10; col++) {
    //         let nested = manager.nestScene(sceneNode);
    //         nested.name = "nested" + row;
    //         let nestedManager = nested._manager as Kb3dManager;
    //         let nestedBox = nestedManager.create(tok.BoxNode);
    //         nestedBox.name = "nestedBox" + row;
    //         if (row % 2 > 0) {
    //             nestedBox.materialId = "rock01";
    //         } else {
    //             nestedBox.materialId = "bricks01";
    //         }
    //         nested.meshes.push(nestedBox);
    //         nested.position = new KbVector(row * 1.5, col * 1.5, 0);
    //     }
    // }

    kbViewer.interaction.onClick.subscribe(p => {
        console.log(p);
    });

    kbViewer.interaction.onKeyboard.subscribe(k => {
        console.log(k);
    });

    const btnAnimate = document.getElementById('btnAnimate');
    if (btnAnimate) {
        btnAnimate.onclick = () => {
            kbViewer.animation
                .queue({
                    name: 'a1',
                    node: box,
                    prop: 'position',
                    toValue: new KbVector(10, 0, 0),
                    duration: 1000,
                    easing: eEasing.quadraticIn,
                })
                .then(() => {
                    return kbViewer.animation.queue({
                        name: 'a2',
                        node: box,
                        prop: 'rotation',
                        toValue: new KbVector(box.eulerRotation.x + 720, 0, 0),
                        duration: 1000,
                    });
                })
                .then(() => {
                    return kbViewer.animation.queue({
                        name: 'a3',
                        node: box,
                        prop: 'position',
                        toValue: new KbVector(0, 0, 0),
                        duration: 1000,
                        easing: eEasing.quadraticOut,
                    });
                });
        };
    }

    const btnStop = document.getElementById('btnStop');
    if (btnStop) {
        btnStop.onclick = () => {
            kbViewer.animation.stop('a1');
        };
    }

    const txtJson = document.getElementById('txtJson') as HTMLTextAreaElement;
    const txtCounter = document.getElementById('txtCounter') as HTMLDivElement;

    const btnToJson = document.getElementById('btnToJson');
    if (btnToJson) {
        btnToJson.onclick = () => {
            txtJson.value = manager.serializeToJson(sceneNode, { prettyPrint: true });
            updateJsonLength();
        };
    }

    const btnToFullJson = document.getElementById('btnToFullJson');
    if (btnToFullJson) {
        btnToFullJson.onclick = () => {
            txtJson.value = manager.serializeToJson(sceneNode, { omitDefaultValues: false, prettyPrint: true });
            updateJsonLength();
        };
    }

    const btnFromJson = document.getElementById('btnFromJson');
    if (btnFromJson) {
        btnFromJson.onclick = () => {
            manager = new Kb3dManager();
            const jsonObject = JSON.parse(txtJson.value);
            sceneNode = manager.create<SceneNode>(Token.SceneNode, jsonObject);
            kbViewer.loadScene({ sceneNode });
        };
    }

    const btnBabylonJson = document.getElementById('btnBabylonJson');
    if (btnBabylonJson) {
        btnBabylonJson.onclick = () => {
            txtJson.value = kbViewer.getBabylonJson();
        };
    }

    const btnWidth = document.getElementById('btnWidth');
    if (btnWidth) {
        btnWidth.onclick = () => {
            box.depth = box.depth + 1;
        };
    }

    const btnMaterialColor = document.getElementById('btnMaterialColor');
    if (btnMaterialColor) {
        btnMaterialColor.onclick = () => {
            //mat.albedoColor = new KbColor(0, 0, 252);
        };
    }

    // let btnToggleVisible = document.getElementById("btnToggleVisible");
    // if (btnToggleVisible) {
    //     btnToggleVisible.onclick = () => {
    //         box.visible = !box.visible;
    //     };
    // }

    const btnSaveMesh = document.getElementById('btnSaveMesh');
    if (btnSaveMesh) {
        btnSaveMesh.onclick = () => {
            const myArray = new ArrayBuffer(512);
            const longInt8View = new Uint8Array(myArray);

            // generate some data
            for (let i = 0; i < longInt8View.length; i++) {
                longInt8View[i] = i % 256;
            }

            const xhr = new XMLHttpRequest();
            xhr.open('POST', '/api/meshes/72b7487f-2ab2-4faf-b034-a1178feeb191', false);
            xhr.send(myArray);
        };
    }

    const btnGetSavedMesh = document.getElementById('btnGetSavedMesh');
    if (btnGetSavedMesh) {
        btnGetSavedMesh.onclick = () => {
            const oReq = new XMLHttpRequest();
            oReq.open('GET', '/api/meshes/72b7487f-2ab2-4faf-b034-a1178feeb191', true);
            oReq.responseType = 'arraybuffer';

            oReq.onload = function (oEvent) {
                const arrayBuffer = oReq.response; // Note: not oReq.responseText
                if (arrayBuffer) {
                    const byteArray = new Uint8Array(arrayBuffer);
                    for (let i = 0; i < byteArray.byteLength; i++) {
                        // do something with each byte in the array
                        console.log(byteArray[i]);
                    }
                }
            };

            oReq.send(null);
        };
    }

    const updateJsonLength = () => {
        txtCounter.innerHTML = new TextEncoder().encode(txtJson.value).length.toString() + ' bytes';
    };
}
